import Auth from '@/screens/Auth/components/Main';
import AuthLogout from '@/screens/Auth/components/Logout';
import AweberVerify from '@/screens/Aweber/components/Verify';
import RDStationVerify from '@/screens/RDStation/components/Verify';
import Locale from '@/Locale';
import Index from '@/Index';

export default [
  {
    path: '/:locale',
    component: Locale,
    children: [
      {
        path: '',
        name: 'Index',
        component: Index,
      },
      {
        path: 'auth',
        name: 'Auth',
        component: Auth,
      },
      {
        path: 'logout',
        name: 'Logout',
        component: AuthLogout,
      },
      {
        path: 'aweber_verify',
        name: 'AweberVerify',
        component: AweberVerify,
      },
      {
        path: 'rdstation_verify',
        name: 'RDStationVerify',
        component: RDStationVerify,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js